export default {
      id: "oc-dashboard-cloud-account-health-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-cloud-account-health",
      toString: function () {
        return this.url;
      }
    }